import React, { Component } from 'react'
import './transportDashboard.scss';
import withRouter from '../lib/withRouter';
import Authentication from '../../session';
import { connect } from 'react-redux';
import { AddStudentIcon, AssignTransportIcon, FilterIcon2, MoneyIcon, ReportsIcon, RouteIcon, StudentIcon } from '../svgIcons';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import ReactApexChart from 'react-apexcharts';
import BranchToClassDD from "../BaseDropdownComponents/BranchToClassDD";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Skeleton } from 'primereact/skeleton'; // Add this import

class TransportDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branchData: [],
            transportData: [],
            selectedBuses: [],
            chartData: null,
            chartOptions: null,
            containerWidth: 0,
            layouts: [
                { i: 'fee-chart', x: 0, y: 0, w: 4, h: 5, minW: 4, maxW: 12, minH: 4 },
                { i: 'allocation-chart', x: 5, y: 5, w: 8, h: 5, minW: 8, maxW: 12, minH: 4 }
            ],
            isDragging: false,
            seatAllocationOptions: {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: { show: false },
                    stacked: false,
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '12px',
                        borderRadius: 2,
                        distributed: false,
                        dataLabels: {
                            position: 'top'
                        }
                    }
                },
                colors: ['#4A3AFF', '#962DFF'], // Reduced to 2 colors
                dataLabels: { enabled: false },
                stroke: {
                    show: true,
                    width: 0,
                    colors: ['transparent']
                },
                grid: {
                    borderColor: "#E5E5EF",
                    strokeDashArray: 5,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 25
                    },
                    yaxis: {
                        lines: {
                            show: true,
                            min: 0
                        }
                    }
                },
            },
            showFilterDialog: false,
            savedDropdownValues: null,
            tempDropdownValues: null,
            dropdownsData: {
                branchId: null,
                boardId: null,
                classId: null
            },
            filteredData: null,
            currentLevelData: {
                summaryCards: {},
                charts: {}
            },
            selectedBranchData: null,
            transportFeeData: null,
            isLoading: false
        }
        this.containerRef = React.createRef();
        this.service = new Service();
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);

        const defaultDropdownData = {
            branchId: null,
            boardId: null,
            classId: null
        };

        this.setState({
            dropdownsData: defaultDropdownData,
            branchInfo: this.props.branchData
        }, () => {
            this.fetchInitialData();
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        if (this.containerRef.current) {
            this.setState({ containerWidth: this.containerRef.current.offsetWidth });
        }
    };

    fetchInitialData = async () => {
        try {
            this.setState({ isLoading: true });
            const url = `${baseUrlAdmin}/transportDashboard/get-dashboard`;

            const payload = {
                academicYear: localStorage.getItem("userAcademicYear"),
            };

            const response = await this.service.post(url, payload, true);

            if (response.status && response.res.status) {
                const dashboardData = response.res.data.data;

                // Find the first branch with transport fee data, then check for vehicle data
                const branchWithData = dashboardData.branches.find(
                    branch => {
                        const hasFeeData = branch.branchData?.summaryCards?.totalFee > 0 ||
                            branch.branchData?.charts?.transportFee?.dueFee?.some(val => val > 0) ||
                            branch.branchData?.charts?.transportFee?.collectedFee?.some(val => val > 0);
                        return hasFeeData;
                    }
                ) || dashboardData.branches.find(
                    branch => branch.branchData?.summaryCards?.vehicleInfo?.length > 0
                ) || dashboardData.branches[0];

                this.setState({
                    transportFeeData: dashboardData,
                    selectedBranchData: branchWithData,
                    currentLevelData: {
                        summaryCards: branchWithData.branchData.summaryCards,
                        charts: branchWithData.branchData.charts
                    },
                    dropdownsData: {
                        branchId: branchWithData.branchId,
                        boardId: null,
                        classId: null
                    }
                }, () => {
                    this.initializeChartData();
                    this.updateDashboardData();
                    this.toast.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Dashboard data loaded successfully',
                        life: 3000
                    });
                });
            } else {
                this.toast.show({
                    severity: 'warn',
                    summary: 'Warning',
                    detail: response.res.message || 'Failed to load dashboard data',
                    life: 3000
                });
            }
        } catch (error) {
            console.error("API Error:", error);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to fetch dashboard data',
                life: 3000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    onFilterData = () => {
        const { dropdownsData, selectedBranchData } = this.state;

        let currentLevelData = {
            summaryCards: selectedBranchData.branchData.summaryCards,
            charts: {
                seatAllocation: selectedBranchData.branchData.charts.seatAllocation,
                transportFee: selectedBranchData.branchData.charts.transportFee
            }
        };

        try {
            if (dropdownsData.boardId) {
                const selectedBoard = selectedBranchData.boards?.find(
                    board => board.boardId === dropdownsData.boardId
                );

                if (selectedBoard) {
                    if (dropdownsData.classId && Array.isArray(dropdownsData.classId) && dropdownsData.classId.length > 0) {
                        // Initialize arrays for sum of collected and due fees
                        const sumCollectedFee = [0, 0, 0, 0];
                        const sumDueFee = [0, 0, 0, 0];
                        let validClassesFound = false;

                        // Sum up fee data for all selected classes
                        dropdownsData.classId.forEach(classId => {
                            const selectedClass = selectedBoard.classes?.find(cls => cls.classId === classId);
                            if (selectedClass?.dashboardData?.charts?.transportFee) {
                                validClassesFound = true;
                                selectedClass.dashboardData.charts.transportFee.collectedFee.forEach((fee, index) => {
                                    sumCollectedFee[index] += fee || 0;
                                });
                                selectedClass.dashboardData.charts.transportFee.dueFee.forEach((fee, index) => {
                                    sumDueFee[index] += fee || 0;
                                });
                            }
                        });

                        if (validClassesFound) {
                            currentLevelData.charts.transportFee = {
                                quarters: ['Q1', 'Q2', 'Q3', 'Q4'],
                                collectedFee: sumCollectedFee,
                                dueFee: sumDueFee
                            };
                        } else {
                            // If no valid classes found, show board level data
                            currentLevelData.charts.transportFee = selectedBoard.boardData.charts.transportFee;
                        }
                    } else {
                        // If no classes selected, show board level data
                        currentLevelData.charts.transportFee = selectedBoard.boardData.charts.transportFee;
                    }
                }
            }

            this.setState({ currentLevelData }, () => {
                this.initializeChartData();
                this.updateDashboardData();
            });

        } catch (error) {
            console.error("Error in filtering data:", error);
            this.setState({ currentLevelData }, () => {
                this.initializeChartData();
                this.updateDashboardData();
            });
        }
    };

    setDropdownValues = (dropdownsData) => {
        this.setState({
            tempDropdownValues: dropdownsData
        });
    };

    applyFilters = () => {
        const dropdownsData = { ...this.state.tempDropdownValues };

        if (dropdownsData.branchId) {
            const selectedBranch = this.state.transportFeeData.branches.find(
                b => b.branchId === dropdownsData.branchId
            );
            if (selectedBranch) {
                this.setState({
                    selectedBranchData: selectedBranch,
                    currentLevelData: {
                        summaryCards: selectedBranch.branchData.summaryCards,
                        charts: selectedBranch.branchData.charts
                    },
                    dropdownsData: {
                        branchId: dropdownsData.branchId,
                        boardId: dropdownsData.boardId || null,
                        classId: dropdownsData.classId || null
                    },
                    showFilterDialog: false,
                    tempDropdownValues: null
                }, () => this.onFilterData());
            }
        } else {
            this.setState({
                dropdownsData: dropdownsData,
                showFilterDialog: false,
                tempDropdownValues: null
            }, () => this.onFilterData());
        }
    };

    cancelFilters = () => {
        this.setState({
            showFilterDialog: false,
            tempDropdownValues: null
        });
    };

    formatCurrencyValue = (value) => {
        if (value >= 100000) {
            return `${(value / 100000).toFixed(1)}L`;  // Convert to lakhs
        } else if (value >= 1000) {
            return `${(value / 1000).toFixed(1)}K`;    // Convert to thousands
        }
        return value.toString();                        // Keep as is for smaller values
    };

    initializeChartData = () => {
        const { currentLevelData } = this.state;

        // Add null checks and default values
        if (!currentLevelData?.charts?.transportFee) return;

        const chartData = {
            labels: currentLevelData.charts.transportFee.quarters || [],
            datasets: [
                {
                    name: 'Collected Fee',
                    data: currentLevelData.charts.transportFee.collectedFee || [0, 0, 0, 0],
                    color: '#962DFF'
                },
                {
                    name: 'Due Fee',
                    data: currentLevelData.charts.transportFee.dueFee || [0, 0, 0, 0],
                    color: '#076EFF'
                }
            ]
        };

        const chartOptions = {
            chart: {
                type: 'line',
                height: '100%',
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                },
                sparkline: {
                    enabled: false
                }
            },
            grid: {
                borderColor: "#E5E5EF",
                strokeDashArray: 5,
                padding: {
                    top: 0,
                    right: 10,
                    bottom: 0,
                    left: 10
                },
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                yaxis: {
                    lines: {
                        show: true,
                        min: 0
                    }
                }
            },
            xaxis: {
                categories: currentLevelData.charts.transportFee.quarters || ['Q1', 'Q2', 'Q3', 'Q4'],
                axisTicks: { show: true },
                axisBorder: { show: true },
                labels: {
                    style: {
                        fontSize: '12px',
                        fontFamily: 'InterRegular'
                    }
                }
            },
            yaxis: {
                labels: {
                    formatter: (value) => this.formatCurrencyValue(value),
                    style: {
                        fontSize: '12px',
                        fontFamily: 'InterRegular'
                    }
                }
            },
            stroke: {
                width: 2,
                curve: 'smooth'
            },
            markers: {
                size: 4,
                strokeWidth: 2,
                hover: {
                    size: 6
                }
            },
            legend: {
                position: 'bottom'
            },
            responsive: [{
                breakpoint: 1024,
                options: {
                    chart: {
                        height: 300
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }],
            tooltip: {
                theme: 'dark',
                shared: true,
                intersect: false,
                y: {
                    formatter: function (value) {
                        return `₹${value.toLocaleString()}`
                    }
                },
                style: {
                    fontSize: '12px',
                    fontFamily: 'Inter'
                },
                custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                    return '<div class="custom-tooltip">' +
                        '<div class="tooltip-title">' +
                        w.globals.labels[dataPointIndex] +
                        '</div>' +
                        '<div class="tooltip-content">' +
                        w.config.series[seriesIndex].name +
                        ': ₹' + series[seriesIndex][dataPointIndex].toLocaleString() +
                        '</div>' +
                        '</div>';
                }
            },
        };

        this.setState({ chartData, chartOptions });
    };

    updateDashboardData = () => {
        const { currentLevelData } = this.state;
        this.updateSummaryCards(currentLevelData.summaryCards);
        this.updateChartData(currentLevelData.charts);
    };

    updateSummaryCards = (summaryCards) => {
        this.setState({
            transportData: [{
                totalRoutes: summaryCards?.totalRoutes || 0,
                totalStudents: summaryCards?.totalStudents || 0,
                totalFee: summaryCards?.totalFee || 0,
                dueFee: summaryCards?.dueFee || 0
            }]
        });
    };

    updateChartData = (chartsData) => {
        if (!chartsData?.transportFee?.quarters) return;

        const transportFeeChart = {
            labels: chartsData.transportFee.quarters || ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    name: 'Collected Fee',
                    data: chartsData.transportFee.collectedFee || [0, 0, 0, 0],
                    color: '#962DFF'
                },
                {
                    name: 'Due Fee',
                    data: chartsData.transportFee.dueFee || [0, 0, 0, 0],
                    color: '#076EFF'
                }
            ]
        };

        if (!chartsData?.seatAllocation?.routes) {
            this.setState({ chartData: transportFeeChart });
            return;
        }

        const seatAllocationData = {
            routes: chartsData.seatAllocation.routes.map(route => route.name || 'Unnamed Route'),
            series: [
                {
                    name: 'Occupied Seats',
                    data: chartsData.seatAllocation.routes.map(route => route.occupiedSeats || 0)
                },
                {
                    name: 'Available Seats',
                    data: chartsData.seatAllocation.routes.map(route => route.availableSeats || 0)
                }
            ]
        };

        this.setState({
            chartData: transportFeeChart,
            seatAllocationData
        });
    };

    onLayoutChange = (layout) => {
        const sortedLayout = [...layout].sort((a, b) => a.y - b.y);
        this.setState({ layouts: sortedLayout });
    };

    onDragStart = (layout, oldItem, newItem, placeholder, e, element) => {
        this.setState({ isDragging: true });
        element.style.zIndex = "1000";
    };

    onDrag = (layout, oldItem, newItem, placeholder, e, element) => {
        if (!this.state.isDragging) return;
        requestAnimationFrame(() => {
            this.setState({ layouts: layout });
        });
    };

    onDragStop = (layout, oldItem, newItem, placeholder, e, element) => {
        element.style.zIndex = "1";
        this.setState({
            layouts: layout,
            isDragging: false
        });
    };

    toggleFilterDialog = () => {
        this.setState(prev => ({
            showFilterDialog: !prev.showFilterDialog,
            savedDropdownValues: !prev.showFilterDialog ? null : prev.dropdownsData,
            tempDropdownValues: !prev.showFilterDialog ? { ...prev.dropdownsData } : null
        }));
    }

    getViewingLevelText = () => {
        const { dropdownsData, selectedBranchData } = this.state;

        if (!dropdownsData.branchId) {
            return 'All Branches';
        }

        const branchName = selectedBranchData?.branchName || 'Branch';

        if (dropdownsData.classId && Array.isArray(dropdownsData.classId) && dropdownsData.classId.length > 0) {
            const classCount = dropdownsData.classId.length;
            return `${branchName} → ${classCount} ${classCount > 1 ? 'Classes' : 'Class'} (Fee Chart Filtered)`;
        }

        if (dropdownsData.boardId) {
            const board = selectedBranchData?.boards?.find(b => b.boardId === dropdownsData.boardId);
            const boardName = board?.boardName || 'Board';
            return `${branchName} → ${boardName} (Fee Chart Filtered)`;
        }

        return `${branchName} (All Data)`;
    }

    renderFilterIcon = () => (
        <div className="filter-icon-container">
            <div className="filter-icon" onClick={this.toggleFilterDialog}>
                <div className="filter-svg">
                    <FilterIcon2 color={"#fff"} />
                </div>
            </div>
            {this.state.showFilterDialog && (
                <Dialog
                    visible={this.state.showFilterDialog}
                    onHide={this.cancelFilters}
                    draggable={false}
                    style={{ width: '400px', height: 'auto' }}
                    header={<h4 className='chart-Title'>Filters</h4>}
                    footer={
                        <div className="flex justify-content-end gap-1">
                            <Button
                                style={{
                                    marginTop: "25px",
                                    marginLeft: "16px",
                                    height: "44px",
                                    borderRadius: "8px",
                                    fontSize: "16px",
                                    background: "#E6E8EA",
                                    color: "#000",
                                    border: "none",
                                    padding: "0 24px",
                                    cursor: "pointer"
                                }}
                                label="Cancel"
                                onClick={this.cancelFilters}
                            />
                            <Button
                                style={{
                                    marginTop: "25px",
                                    marginLeft: "16px",
                                    height: "44px",
                                    borderRadius: "8px",
                                    fontSize: "16px",
                                    background: "#076EFF",
                                    color: "#fff",
                                    border: "none",
                                    padding: "0 24px",
                                    cursor: "pointer"
                                }}
                                label="Apply"
                                onClick={this.applyFilters}
                            />
                        </div>
                    }
                >
                    <BranchToClassDD
                        setValues={this.setDropdownValues}
                        rowData={this.state.rowData || { value: [] }}
                        initialValues={this.state.tempDropdownValues || this.state.dropdownsData}
                    />
                </Dialog>
            )}
        </div>
    );

    renderTransportReportHeader = () => (
        <div className="flex flex-column">
            <h4 className="chart-Title">Bus Status</h4>
            <div className="flex flex-row justify-content-start align-items-center">
                <div className="flex align-items-center">
                    <span className="chart-sub-tilte">Overview</span>
                </div>
                <div className="flex align-items-center ml-auto">
                    <div
                        className="select-button-wrapper prevent-grid-drag"
                        onMouseDown={e => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                        onClick={e => {
                            e.stopPropagation();
                            e.preventDefault();
                            this.props.navigate('/routeUtilizationreport');
                        }}
                        style={{ cursor: 'pointer', position: 'relative', zIndex: 1001 }}
                    >
                        <ReportsIcon />
                    </div>
                </div>
            </div>
        </div>
    );

    renderTransportTable = () => {
        const { currentLevelData } = this.state;
        const vehicleInfo = currentLevelData?.summaryCards?.vehicleInfo || [];

        // Transform vehicle data to match table headers
        const transformedData = vehicleInfo.map(vehicle => ({
            routeName: vehicle.routeName,
            vehicleType: vehicle.vehicleType,
            vehicleId: vehicle.vehicleId,
            vehicleNumber: vehicle.vehicleRegistrationNo,
            vehicleName: vehicle.vehicleName,
            totalStudents: vehicle.routeId || 'Not Assigned', // Route Name
            presentCount: vehicle.routeId ? 'Active' : 'Inactive', // Route Status
            gps: vehicle.isGps ? 'Enabled' : 'Disabled', // GPS
            seatingCapacity: vehicle.seatingCapacity, // Seating Capacity
            allocatedStudents: vehicle.assignedCapacity || 0, // Allocated Students
            status: vehicle.vehicleCategory // Status
        }));

        return (
            <div style={{
                overflow: 'auto',
                maxHeight: '350px',
                width: '100%'
            }}>
                <DataTable
                    value={transformedData}
                    responsiveLayout="scroll"
                    className="transport-absentee-table"
                    scrollable
                    scrollHeight="300px"
                    style={{ width: '100%' }}
                    resizableColumns
                    columnResizeMode="fit"
                >
                    <Column field="vehicleNumber" header="Vehicle Number" />
                    <Column field="vehicleType" header="Vehicle Type" />
                    <Column field="vehicleName" header="Vehicle Name" />
                    <Column field="routeName" header="Route Name" />
                    {/* <Column field="" header="Route Status" /> */}
                    <Column
                        field="gps"
                        header="GPS"
                        body={(rowData) => (
                            <InputSwitch
                                checked={rowData.gps === 'Enabled'}
                                onChange={() => { }} // Add handler if needed
                                className="p-inputswitch-sm"
                            />
                        )}
                    />
                    <Column field="seatingCapacity" header="Seating Capacity" />
                    <Column field="allocatedStudents" header="Allocated Students" />
                    <Column
                        field="status"
                        header="Status"
                        body={(rowData) => (
                            <span style={{ fontWeight: '600' }}>
                                N/A
                            </span>
                        )}
                    />
                </DataTable>
            </div>
        );
    };

    renderFeeChart = () => (
        <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
            <div className="chart-header">
                <div className="flex flex-column">
                    <h4 className="chart-Title">Transport Fee</h4>
                    <div className="flex flex-row justify-content-start align-items-center">
                        <span className="transport-chart-sub-tilte">Collect Fee vs Due Fee</span>
                        <div className="flex align-items-center ml-auto">
                            <div
                                className="select-button-wrapper prevent-grid-drag ml-2 "
                                onClick={() => this.props.navigate('/transportfeereport')}
                            >
                                <ReportsIcon />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span className="icon-divider"></span>
            {/* Add legend section after divider */}
            <div className="fee-chart-legend">
                {this.state.chartData?.datasets.map((dataset, index) => (
                    <div key={index} className="legend-item">
                        <span
                            className="legend-marker"
                            style={{ backgroundColor: dataset.color }}
                        ></span>
                        <span className="legend-text">{dataset.name}</span>
                    </div>
                ))}
            </div>
            <div className="chart-body">
                {this.state.chartData?.datasets?.length > 0 && this.state.chartOptions && (
                    <ReactApexChart
                        type="line"
                        options={{
                            ...this.state.chartOptions,
                            legend: { show: false },
                            xaxis: {
                                ...this.state.chartOptions.xaxis,
                                categories: this.state.chartData.labels || ['Q1', 'Q2', 'Q3', 'Q4']
                            }
                        }}
                        series={this.state.chartData.datasets}
                        height="100%"
                        width="100%"
                    />
                )}
            </div>
        </div>
    );

    renderSeatAllocationChart = () => {
        const { seatAllocationData } = this.state;
        if (!seatAllocationData) return null;

        const chartOptions = {
            ...this.state.seatAllocationOptions,
            chart: {
                ...this.state.seatAllocationOptions.chart,
                type: 'bar',
                height: '100%',
                width: '100%',
                stacked: false,
                toolbar: { show: false }
            },
            xaxis: {
                categories: seatAllocationData.routes,
                labels: {
                    rotate: -45,
                    style: { fontSize: '12px' },
                    maxHeight: 100,
                    trim: true
                },
                axisTicks: { show: true },
                axisBorder: { show: true },
                tickPlacement: 'on'
            },
            yaxis: {
                min: 0,
                max: Math.max(
                    ...seatAllocationData.series.flatMap(s => s.data)
                ) + 5,
                tickAmount: 5,
                forceNiceScale: true,
                labels: {
                    formatter: val => Math.max(0, Math.round(val)),
                    style: {
                        fontSize: '12px',
                        fontFamily: 'InterRegular'
                    }
                }
            },
            tooltip: {
                y: {
                    formatter: val => `${Math.round(val)}`
                }
            },
            legend: {
                show: false
            }
        };

        return (
            <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-row justify-content-between align-items-center w-100">
                        <div className="flex flex-column">
                            <h4 className="chart-Title">Seat Allocation Status</h4>
                            <span className="transport-chart-sub-tilte">Overview</span>
                        </div>
                        <div className="flex flex-row align-items-center">
                            <div className="custom-legend flex align-items-center mr-3">
                                {seatAllocationData.series.map((series, index) => (
                                    <div key={index} className="legend-item flex align-items-center">
                                        <span
                                            className="legend-marker"
                                            style={{
                                                backgroundColor: chartOptions.colors[index],
                                                width: '12px',
                                                height: '12px',
                                                borderRadius: '50%',
                                                display: 'inline-block',
                                                marginRight: '8px'
                                            }}
                                        ></span>
                                        <span className="legend-text">{series.name}</span>
                                    </div>
                                ))}
                            </div>
                            <div
                                className="reports-icon-wrapper prevent-grid-drag"
                                onClick={() => this.props.navigate('/routeUtilizationreport')}
                            >
                                <ReportsIcon />
                            </div>
                        </div>
                    </div>
                </div>
                <span className="icon-divider"></span>
                <div className="chart-body">
                    <ReactApexChart
                        options={chartOptions}
                        series={seatAllocationData.series}
                        type="bar"
                        width="100%"
                        height="100%"
                    />
                </div>
            </div>
        );
    };

    renderShimmerCards = () => (
        <div className='dashboard-summary-cards'>
            <div className='cards'>
                <div className="transport-card">
                    <div className="transport-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="8rem" height="1rem" />
                    </div>
                    <div className="transport-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
                <div className="transport-card">
                    <div className="transport-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="10rem" height="1rem" />
                    </div>
                    <div className="transport-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
            </div>
            <div className='cards'>
                <div className="transport-card">
                    <div className="transport-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="8rem" height="1rem" />
                    </div>
                    <div className="transport-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
                <div className="transport-card">
                    <div className="transport-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="7rem" height="1rem" />
                    </div>
                    <div className="transport-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
            </div>
        </div>
    );

    renderShimmerQuickActions = () => (
        <div className='quick-actions-container'>
            <Skeleton width="8rem" height="1.25rem" className="mb-3" />
            <div className="flex justify-content-between align-items-center quick-actions">
                <div className="text-center quick-action-item">
                    <Skeleton shape="circle" size="3rem" className="mb-2" />
                    <Skeleton width="6rem" height="1rem" />
                </div>
                <div className="text-center quick-action-item">
                    <Skeleton shape="circle" size="3rem" className="mb-2" />
                    <Skeleton width="5rem" height="1rem" />
                </div>
                <div className="text-center quick-action-item">
                    <Skeleton shape="circle" size="3rem" className="mb-2" />
                    <Skeleton width="6rem" height="1rem" />
                </div>
            </div>
        </div>
    );

    renderShimmerTable = () => (
        <div className="transport-bus-report-data" style={{ width: '100%', maxWidth: '100%', overflow: 'auto' }}>
            <Skeleton width="100%" height="40px" className="mb-2" />
            {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="30px" className="mb-2" />
            ))}
        </div>
    );

    renderShimmerCharts = () => (
        <div ref={this.containerRef} style={{ width: '100%', marginTop: '19px' }}>
            <div className="flex gap-4">
                <div className="chart-container" style={{ minHeight: '400px', flex: 1 }}>
                    <div className='card' style={{ background: 'transparent', boxShadow: 'none', border: 'none', height: '100%' }}>
                        <div className="chart-header mb-3">
                            <Skeleton width="8rem" height="1.5rem" className="mb-2" />
                            <Skeleton width="6rem" height="1rem" />
                        </div>
                        <div className="chart-body">
                            <Skeleton width="100%" height="250px" />
                        </div>
                    </div>
                </div>
                <div className="chart-container" style={{ minWidth: '400px', minHeight: '400px' }}>
                    <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                        <div className="chart-header mb-3">
                            <Skeleton width="6rem" height="1.5rem" className="mb-2" />
                            <Skeleton width="4rem" height="1rem" />
                        </div>
                        <div className="chart-body">
                            <Skeleton shape="circle" size="200px" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    render() {
        const { currentLevelData } = this.state;
        const summaryData = currentLevelData.summaryCards || {};

        const containerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#E6E8EA',
            padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
            overflow: 'auto',
            transition: 'padding 0.3s',
            paddingBottom: '30px',
        };

        if (this.state.isLoading) {
            return (
                <div style={containerStyle}>
                    <div className="transport-dashboard-container">
                        <div className="dashboard-main-section">
                            {this.renderShimmerCards()}
                            {this.renderShimmerQuickActions()}
                        </div>
                        <div className='transport-bus-report'>
                            <div className="transport-bus-report-header">
                                <Skeleton width="8rem" height="1.5rem" className="mb-2" />
                                <Skeleton width="100%" height="2px" className="mb-2" />
                                {this.renderShimmerTable()}
                            </div>
                        </div>
                        {this.renderShimmerCharts()}
                    </div>
                    {this.renderFilterIcon()}
                    <Toast ref={(el) => this.toast = el} position="bottom-right" />
                </div>
            );
        }

        return (
            <div style={containerStyle}>
                <div className="transport-dashboard-container">
                    <div className="dashboard-main-section">
                        <div className='dashboard-summary-cards'>
                            <div className='cards'>
                                <div className="transport-card">
                                    <div className="transport-icon-group">
                                        <div className="transport-icon">
                                            <RouteIcon />
                                        </div>
                                        <span className="transport-label">Routes</span>
                                    </div>
                                    <div className="transport-divider"></div>
                                    <div className="transport-amount">
                                        {summaryData.totalRoutes || 0}
                                    </div>
                                </div>
                                <div className="transport-card">
                                    <div className="transport-icon-group">
                                        <div className="transport-icon">
                                            <StudentIcon />
                                        </div>
                                        <span className="transport-label">Students Count</span>
                                    </div>
                                    <div className="transport-divider"></div>
                                    <div className="transport-amount">
                                        {summaryData.totalStudents || 0}
                                    </div>
                                </div>
                            </div>
                            <div className='cards'>
                                <div className="transport-card">
                                    <div className="transport-icon-group">
                                        <div className="transport-icon">
                                            <MoneyIcon />
                                        </div>
                                        <span className="transport-label">Transport Total Fee</span>
                                    </div>
                                    <div className="transport-divider"></div>
                                    <div className="transport-amount">
                                        ₹{(summaryData.totalFee || 0).toLocaleString()}
                                    </div>
                                </div>
                                <div className="transport-card">
                                    <div className="transport-icon-group">
                                        <div className="transport-icon">
                                            <MoneyIcon />
                                        </div>
                                        <span className="transport-label">Transport Fee Due</span>
                                    </div>
                                    <div className="transport-divider"></div>
                                    <div className="transport-amount">
                                        ₹{(summaryData.dueFee || 0).toLocaleString()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='quick-actions-container'>
                            <h5 className="quick-actions-header">Quick Actions</h5>
                            <div className="flex justify-content-between align-items-center quick-actions">
                                <div className="text-center quick-action-item" onClick={() => this.props.navigate('/routemanagement')}>
                                    <AddStudentIcon className="transport-icon" />
                                    <p className='quickActions-title'>Add Route</p>
                                </div>
                                <div className="text-center quick-action-item" onClick={() => this.props.navigate('/assigntransport')} >
                                    <AssignTransportIcon className="transport-icon" />
                                    <p className='quickActions-title'>Assign Transport</p>
                                </div>
                                <div className="text-center quick-action-item" onClick={() => this.props.navigate('/routemanagement')}>
                                    <AddStudentIcon className="transport-icon" />
                                    <p className='quickActions-title'>Add Stop</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='transport-bus-report'>
                            <div className="transport-bus-report-header">
                                {this.renderTransportReportHeader()}
                                <div className="divider"></div>
                                <div className="transport-bus-report-data" style={{
                                    width: '100%',
                                    maxWidth: '100%',
                                    overflow: 'auto',
                                }}>
                                    {this.renderTransportTable()}
                                </div>
                            </div>
                        </div>
                        <div ref={this.containerRef} style={{ width: '100%', marginTop: '19px' }}>
                            <GridLayout
                                className="layout"
                                layout={this.state.layouts}
                                cols={12}
                                rowHeight={80}
                                width={this.state.containerWidth}
                                margin={[15, 15]}
                                containerPadding={[0, 0]}
                                isDraggable={true}
                                isResizable={true}
                                resizeHandles={['se']}
                                onLayoutChange={this.onLayoutChange}
                                compactType="vertical"
                                preventCollision={false}
                                verticalCompact={true}
                                measureBeforeMount={true}
                                onDragStart={this.onDragStart}
                                onDrag={this.onDrag}
                                onDragStop={this.onDragStop}
                                useCSSTransforms={true}
                                transformScale={1}
                                draggableCancel=".prevent-grid-drag"
                            >
                                <div key="fee-chart" className="chart-container">
                                    {this.renderFeeChart()}
                                </div>
                                <div key="allocation-chart" className="chart-container">
                                    {this.renderSeatAllocationChart()}
                                </div>
                            </GridLayout>
                        </div>
                    </div>
                </div>
                {this.renderFilterIcon()}
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>
        )
    }
}

const mapStatesToProps = (state) => ({
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
})
export default connect(mapStatesToProps, {})(Authentication(withRouter(TransportDashboard)));